



































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import DateInput from '@/components/inputs/DateInput.vue'

@Component({
  props: {
    deposit: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    DateInput
  }
})
export default class PostInPccModal extends Vue {
  effectiveDate: Date = new Date()

  mounted () {
    this.effectiveDate = new Date(this.$props.deposit.depositDate.replace('Z', ''))
  }

  changeEffectiveDate (date: Date | string) {
    this.effectiveDate = new Date(date)
  }

  confirm () {
    this.$emit('confirm', this.effectiveDate)
  }
}
